module.exports = __webpack_public_path__ + "img/background.fdc753ba.jpg";